import React from 'react';
import { get } from 'lodash';
import { Link, withRouter } from 'react-router-dom';

import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';

const EditButton = ({ item, match, size = 'small' })=>{
  if (!get(item, 'id')) {
    return null;
  }
  return (
    <IconButton component={Link} to={`${match.url}/${item.id}`}>
      <EditIcon fontSize={size} />
    </IconButton>
  );
};

export default withRouter(EditButton);